import {
  DELETE_GOLF_COURSE_FORMATS_BY_ID,
  DELETE_GOLF_COURSE_FORMATS_BY_ID_SUCCESS,
  DELETE_GOLF_COURSE_FORMATS_BY_ID_ERROR,
  DELETE_GOLF_COURSE_FORMATS_BY_ID_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const deleteGolfCourseFormatById = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_GOLF_COURSE_FORMATS_BY_ID:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DELETE_GOLF_COURSE_FORMATS_BY_ID_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DELETE_GOLF_COURSE_FORMATS_BY_ID_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DELETE_GOLF_COURSE_FORMATS_BY_ID_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteGolfCourseFormatById;
